module.exports = __webpack_public_path__ + "img/logo.d92c8a2b.png";